import {Component, Inject, ChangeDetectionStrategy} from '@angular/core';
import {WaButtonDirective, WaDialogDirective, WaIconDirective, WaToastService} from "angular-awesome";
import {DatePipe} from "@angular/common";
import {DIALOG_DATA, DialogRef} from "@angular/cdk/dialog";
import {StaffMemberAssignmentsData} from "../../../api/models/exam-assignments";
import {Survey} from "../../../api/models/survey";
import {Exam} from "../../../api/models/exam";
import {StaffMember} from "../../../api/models/staff-member";
import {DATE_FORMAT, TIME_FORMAT} from "../../../api/constants";

@Component({
  selector: 'app-staffmember-assignments-supervision-dialog',
  imports: [WaButtonDirective, WaDialogDirective, DatePipe, WaIconDirective],
  templateUrl: './staffmember-assignments-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './staffmember-assignments-dialog.component.scss',
})
export class StaffmemberAssignmentsDialogComponent {

  survey: Survey | null = null;
  staffMember: StaffMember | null = null;
  fixedSupervising: Exam[] = [];
  fixedCorrecting: Exam[] = [];
  suggestedSupervising: Exam[] = [];
  suggestedCorrecting: Exam[] = [];
  excludedSupervising: Exam[] = [];
  excludedCorrecting: Exam[] = [];

  constructor(private dialogRef: DialogRef<StaffMemberAssignmentsData>, private toastService: WaToastService, @Inject(DIALOG_DATA) data: StaffMemberAssignmentsData, @Inject(DATE_FORMAT) public dateFormat: string, @Inject(TIME_FORMAT) public timeFormat: string) {
    if (!data) {
      return;
    }
    if (!data?.survey) {
      return;
    }
    if (!data?.staffMember) {
      return;
    }
    this.survey = data.survey;
    this.staffMember = data.staffMember;

    this.fixedSupervising = data?.fixedSupervising ?? [];
    this.fixedCorrecting = data?.fixedCorrecting ?? [];
    this.suggestedSupervising = data?.suggestedSupervising ?? [];
    this.suggestedCorrecting = data?.suggestedCorrecting ?? [];
    this.excludedSupervising = data?.excludedSupervising ?? [];
    this.excludedCorrecting = data?.excludedCorrecting ?? [];

    // this.staffMembers = [...data.staffMembers].sort(this.compareStaffMembers);
    // this.fixedCorrectors = [...data.fixedCorrectors].sort(this.compareStaffMembers);
    // this.suggestedCorrectors = [...data.suggestedCorrectors].sort(this.compareStaffMembers);
    // this.excludedCorrectors = [...data.excludedCorrectors].sort(this.compareStaffMembers);
    // // exclude elements that are already listed in fixedCorrectors, suggestedCorrectors or excludedCorrectors
    // const excludedIds = new Set<number>([
    //   ...this.fixedCorrectors.map(s => s.id),
    //   ...this.suggestedCorrectors.map(s => s.id),
    //   ...this.excludedCorrectors.map(s => s.id)
    // ]);
    // this.staffMembers = this.staffMembers.filter(s => !excludedIds.has(s.id));
  }

  hasSupervisingData() {
    return (this.fixedSupervising.length !== 0 || this.suggestedSupervising.length !== 0 || this.excludedSupervising.length !== 0)
  }

  hasCorrectingData() {
    return (this.fixedCorrecting.length !== 0 || this.suggestedCorrecting.length !== 0 || this.excludedCorrecting.length !== 0)
  }

  cancel(): void {
    this.dialogRef.close();
  }

  apply(): void {
    this.dialogRef.close();
  }
}
